<div class="container-fluider" *ngIf="app$ | async as app" style="padding-top: env(safe-area-inset-top, 0)">
  <lib-sign-up-form
    (leavePageEvent)="leavePage($event)"
    (signUpSubmitEvent)="submitFormData($event)"
    [isCheckout]="app.isCheckout"
  >
  </lib-sign-up-form>
</div>
